import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = { url: String }

  connect() {
    history.replaceState(history.state, "", this.urlValue)
  }
}
